import { useState, useMemo } from 'react';

// Left rail: every product, with its sub-product count and how many of those are
// priced for the selected reseller. Selecting one drives the whole right pane.
export function ProductList({ products, selectedId, onSelect, reseller }) {
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? products.filter((p) => p.name.toLowerCase().includes(s)) : products;
  }, [products, q]);

  return (
    <div className="flex h-full flex-col overflow-hidden rounded-2xl bg-white/80 shadow-sm ring-1 ring-slate-900/5 dark:bg-slate-900/60 dark:ring-white/10">
      <div className="shrink-0 border-b border-slate-100 px-4 py-3.5 dark:border-white/10">
        <h3 className="font-semibold text-navy-800 dark:text-slate-100">
          Products <span className="text-slate-400 dark:text-slate-500">({products.length})</span>
        </h3>
        <div className="relative mt-2.5">
          <svg className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="9" cy="9" r="6" /><path d="M14 14l3 3" strokeLinecap="round" /></svg>
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search products…"
            className="w-full rounded-xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand/40 dark:border-white/15 dark:bg-slate-800 dark:text-slate-200"
          />
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto p-2">
        {!filtered.length && (
          <p className="py-8 text-center text-sm text-slate-400 dark:text-slate-500">No products match.</p>
        )}
        {filtered.map((p) => {
          const active = p.id === selectedId;
          const priced = reseller
            ? p.subProducts.filter((s) => s.isConfigured).length
            : p.subProducts.filter((s) => s.configuredCount > 0).length;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onSelect(p.id)}
              className={`mb-1 flex w-full items-center gap-2.5 rounded-xl px-3 py-2.5 text-left transition-colors ${active
                ? 'bg-brand/10 ring-1 ring-brand/30 dark:bg-brand/20'
                : 'hover:bg-slate-50 dark:hover:bg-white/5'}`}
            >
              <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-xs font-bold ${active
                ? 'bg-brand text-white'
                : 'bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-400'}`}
              >
                {p.name.slice(0, 2).toUpperCase()}
              </span>
              <span className="min-w-0 flex-1">
                <span dir="auto" className={`block truncate text-sm font-medium ${active ? 'text-brand-dark dark:text-brand-light' : 'text-slate-700 dark:text-slate-200'}`}>
                  {p.name}
                </span>
                {priced > 0 && (
                  <span className="block text-[11px] text-slate-400 dark:text-slate-500">{priced} priced</span>
                )}
              </span>
              <span className={`shrink-0 rounded-md px-1.5 py-0.5 text-[11px] font-semibold ${active
                ? 'bg-brand/20 text-brand-dark dark:text-brand-light'
                : 'bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-slate-400'}`}
              >
                {p.subProducts.length}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
